import { TimeObject } from '@/Utils/timeTranslate';
import { InputNumber } from 'antd';
import React, { useEffect, useState } from 'react';

interface PostStartLoopTimeEditorProps {
  timeObject: TimeObject;
  onTimeObjectChange: (timeObject: TimeObject) => void;
}

const PostStartLoopTimeEditor = ({
  timeObject,
  onTimeObjectChange,
}: PostStartLoopTimeEditorProps) => {
  const [hour, setHour] = useState<string | null>('0');
  const [minute, setMinute] = useState<string | null>('0');
  const [second, setSecond] = useState<string | null>('0');

  const onHourChange = (value: string | null) => {
    setHour(value ?? '0');
    onTimeObjectChange({ ...timeObject, hour: value ?? '0' });
  };

  const onMinuteChange = (value: string | null) => {
    setMinute(value ?? '0');
    onTimeObjectChange({ ...timeObject, minute: value ?? '0' });
  };

  const onSecondChange = (value: string | null) => {
    setSecond(value ?? '0');
    onTimeObjectChange({ ...timeObject, second: value ?? '0' });
  };

  useEffect(() => {
    if (timeObject) {
      setHour(timeObject.hour ?? '0');
      setMinute(timeObject.minute ?? '0');
      setSecond(timeObject.second ?? '0');
    }
  }, [timeObject]);

  return (
    <div className="flex-row">
      <InputNumber
        className="me-2 w-12"
        placeholder="00"
        value={hour}
        onChange={onHourChange}
        min="0"
        controls={false}
      />
      :
      <InputNumber
        className="ms-2 me-1 w-12"
        placeholder="00"
        value={minute}
        onChange={onMinuteChange}
        min="0"
        max="59"
        controls={false}
      />
      :
      <InputNumber
        className="ms-2 w-12"
        placeholder="00"
        value={second}
        onChange={onSecondChange}
        min="0"
        max="59"
        controls={false}
      />{' '}
    </div>
  );
};

export default PostStartLoopTimeEditor;
